export default "__VITE_ASSET__784e8694__"